import { bsrmAppServiceApi } from "../../../app/bsrm/bsrmAppServiceApi";
import { BASE_API_BSRM } from "../../../constants/apiUrl";
import {
  GetBusinessUnitResponseType,
  GetDistrictListResponseType,
  GetOverviewResponseType,
  GetTopDealersResponseType,
  GetTopPartiesResponseType,
  GetTransactionsChartResponseType,
  GetZoneListResponseType,
} from "../../../types/bsrm/dashboard";

export const dashboardApi = bsrmAppServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getOverview: builder.query<GetOverviewResponseType, object>({
      query: (queryArgs) => ({
        url: BASE_API_BSRM.getOverview,
        ...queryArgs,
      }),
    }),
    getTopDealers: builder.query<GetTopDealersResponseType, object>({
      query: (queryArgs) => ({
        url: BASE_API_BSRM.getTopDealers,
        ...queryArgs,
      }),
    }),
    getTransactionsGraph: builder.query<
      GetTransactionsChartResponseType,
      object
    >({
      query: (queryArgs) => ({
        url: BASE_API_BSRM.getTransactionsGraph,
        ...queryArgs,
      }),
    }),
    getZoneList: builder.query<GetZoneListResponseType, object>({
      query: (queryArgs) => ({
        url: BASE_API_BSRM.getZoneList,
        ...queryArgs,
      }),
    }),
    getDistrictList: builder.query<GetDistrictListResponseType, object>({
      query: (queryArgs) => ({
        url: BASE_API_BSRM.getDistrictList,
        ...queryArgs,
      }),
    }),
    getBusinessUnit: builder.query<GetBusinessUnitResponseType, object>({
      query: (queryArgs) => ({
        url: BASE_API_BSRM.getBusinessUnit,
        ...queryArgs,
      }),
    }),
    getTopParties: builder.query<GetTopPartiesResponseType, object>({
      query: (queryArgs) => ({
        url: BASE_API_BSRM.getTopParties,
        ...queryArgs,
      }),
    }),
  }),
});

export const {
  useGetOverviewQuery,
  useGetTopDealersQuery,
  useGetTransactionsGraphQuery,
  useGetZoneListQuery,
  useGetDistrictListQuery,
  useGetBusinessUnitQuery,
  useGetTopPartiesQuery,
} = dashboardApi;
